export class EmailBH {
   emisorId: string;
   bHId: string;
   emitida: boolean;
   cCs: string[];
   cCOs: string[];
   to: string[];
}
